import { useSelector } from 'react-redux';
import { WaveNoiseOptionalTag } from './WaveNoiseOptionalTag';
import { noiseWaveForLeadSelector } from '../../wave/selectors/wave.selectors';
import { noiseTagFilterSelector } from '../selectors/strip.selectors';
import { useStrip } from '../hooks/useStrip';

export const WaveNoiseOptionalTags = () => {
  const strip = useStrip();
  const tagFilter = useSelector(noiseTagFilterSelector(strip.stripId));
  const waves = useSelector(noiseWaveForLeadSelector(strip.leads, tagFilter));

  return (
    <>
      {waves.map((wave) => (
        <WaveNoiseOptionalTag key={wave.id} wave={wave} />
      ))}
    </>
  );
};
